import { useState, useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Eye, EyeOff, ChevronDown, Search } from 'lucide-react'
import '../styles/login.css'
import { BicoinAuthPanel } from '../components/BicoinAuthPanel'
import { BicoinLogo } from '../components/BicoinLogo'
import { registerUser } from '../services/userService'
import { useToast } from '../context/ToastContext'

export interface Country {
  name: string
  iso: string
  dialCode: string
  flag: string
}

export const COUNTRIES: Country[] = [
  { name: 'Afghanistan', iso: 'AF', dialCode: '+93', flag: '🇦🇫' },
  { name: 'Albania', iso: 'AL', dialCode: '+355', flag: '🇦🇱' },
  { name: 'Algeria', iso: 'DZ', dialCode: '+213', flag: '🇩🇿' },
  { name: 'Andorra', iso: 'AD', dialCode: '+376', flag: '🇦🇩' },
  { name: 'Angola', iso: 'AO', dialCode: '+244', flag: '🇦🇴' },
  { name: 'Antigua and Barbuda', iso: 'AG', dialCode: '+1-268', flag: '🇦🇬' },
  { name: 'Argentina', iso: 'AR', dialCode: '+54', flag: '🇦🇷' },
  { name: 'Armenia', iso: 'AM', dialCode: '+374', flag: '🇦🇲' },
  { name: 'Australia', iso: 'AU', dialCode: '+61', flag: '🇦🇺' },
  { name: 'Austria', iso: 'AT', dialCode: '+43', flag: '🇦🇹' },
  { name: 'Azerbaijan', iso: 'AZ', dialCode: '+994', flag: '🇦🇿' },
  { name: 'Bahamas', iso: 'BS', dialCode: '+1-242', flag: '🇧🇸' },
  { name: 'Bahrain', iso: 'BH', dialCode: '+973', flag: '🇧🇭' },
  { name: 'Bangladesh', iso: 'BD', dialCode: '+880', flag: '🇧🇩' },
  { name: 'Barbados', iso: 'BB', dialCode: '+1-246', flag: '🇧🇧' },
  { name: 'Belarus', iso: 'BY', dialCode: '+375', flag: '🇧🇾' },
  { name: 'Belgium', iso: 'BE', dialCode: '+32', flag: '🇧🇪' },
  { name: 'Belize', iso: 'BZ', dialCode: '+501', flag: '🇧🇿' },
  { name: 'Benin', iso: 'BJ', dialCode: '+229', flag: '🇧🇯' },
  { name: 'Bhutan', iso: 'BT', dialCode: '+975', flag: '🇧🇹' },
  { name: 'Bolivia', iso: 'BO', dialCode: '+591', flag: '🇧🇴' },
  { name: 'Bosnia and Herzegovina', iso: 'BA', dialCode: '+387', flag: '🇧🇦' },
  { name: 'Botswana', iso: 'BW', dialCode: '+267', flag: '🇧🇼' },
  { name: 'Brazil', iso: 'BR', dialCode: '+55', flag: '🇧🇷' },
  { name: 'Brunei', iso: 'BN', dialCode: '+673', flag: '🇧🇳' },
  { name: 'Bulgaria', iso: 'BG', dialCode: '+359', flag: '🇧🇬' },
  { name: 'Burkina Faso', iso: 'BF', dialCode: '+226', flag: '🇧🇫' },
  { name: 'Burundi', iso: 'BI', dialCode: '+257', flag: '🇧🇮' },
  { name: 'Cabo Verde', iso: 'CV', dialCode: '+238', flag: '🇨🇻' },
  { name: 'Cambodia', iso: 'KH', dialCode: '+855', flag: '🇰🇭' },
  { name: 'Cameroon', iso: 'CM', dialCode: '+237', flag: '🇨🇲' },
  { name: 'Canada', iso: 'CA', dialCode: '+1', flag: '🇨🇦' },
  { name: 'Central African Republic', iso: 'CF', dialCode: '+236', flag: '🇨🇫' },
  { name: 'Chad', iso: 'TD', dialCode: '+235', flag: '🇹🇩' },
  { name: 'Chile', iso: 'CL', dialCode: '+56', flag: '🇨🇱' },
  { name: 'China', iso: 'CN', dialCode: '+86', flag: '🇨🇳' },
  { name: 'Colombia', iso: 'CO', dialCode: '+57', flag: '🇨🇴' },
  { name: 'Comoros', iso: 'KM', dialCode: '+269', flag: '🇰🇲' },
  { name: 'Congo (DRC)', iso: 'CD', dialCode: '+243', flag: '🇨🇩' },
  { name: 'Congo (Republic)', iso: 'CG', dialCode: '+242', flag: '🇨🇬' },
  { name: 'Costa Rica', iso: 'CR', dialCode: '+506', flag: '🇨🇷' },
  { name: 'Croatia', iso: 'HR', dialCode: '+385', flag: '🇭🇷' },
  { name: 'Cuba', iso: 'CU', dialCode: '+53', flag: '🇨🇺' },
  { name: 'Cyprus', iso: 'CY', dialCode: '+357', flag: '🇨🇾' },
  { name: 'Czech Republic', iso: 'CZ', dialCode: '+420', flag: '🇨🇿' },
  { name: 'Denmark', iso: 'DK', dialCode: '+45', flag: '🇩🇰' },
  { name: 'Djibouti', iso: 'DJ', dialCode: '+253', flag: '🇩🇯' },
  { name: 'Dominica', iso: 'DM', dialCode: '+1-767', flag: '🇩🇲' },
  { name: 'Dominican Republic', iso: 'DO', dialCode: '+1-809', flag: '🇩🇴' },
  { name: 'Ecuador', iso: 'EC', dialCode: '+593', flag: '🇪🇨' },
  { name: 'Egypt', iso: 'EG', dialCode: '+20', flag: '🇪🇬' },
  { name: 'El Salvador', iso: 'SV', dialCode: '+503', flag: '🇸🇻' },
  { name: 'Equatorial Guinea', iso: 'GQ', dialCode: '+240', flag: '🇬🇶' },
  { name: 'Eritrea', iso: 'ER', dialCode: '+291', flag: '🇪🇷' },
  { name: 'Estonia', iso: 'EE', dialCode: '+372', flag: '🇪🇪' },
  { name: 'Eswatini', iso: 'SZ', dialCode: '+268', flag: '🇸🇿' },
  { name: 'Ethiopia', iso: 'ET', dialCode: '+251', flag: '🇪🇹' },
  { name: 'Fiji', iso: 'FJ', dialCode: '+679', flag: '🇫🇯' },
  { name: 'Finland', iso: 'FI', dialCode: '+358', flag: '🇫🇮' },
  { name: 'France', iso: 'FR', dialCode: '+33', flag: '🇫🇷' },
  { name: 'Gabon', iso: 'GA', dialCode: '+241', flag: '🇬🇦' },
  { name: 'Gambia', iso: 'GM', dialCode: '+220', flag: '🇬🇲' },
  { name: 'Georgia', iso: 'GE', dialCode: '+995', flag: '🇬🇪' },
  { name: 'Germany', iso: 'DE', dialCode: '+49', flag: '🇩🇪' },
  { name: 'Ghana', iso: 'GH', dialCode: '+233', flag: '🇬🇭' },
  { name: 'Greece', iso: 'GR', dialCode: '+30', flag: '🇬🇷' },
  { name: 'Grenada', iso: 'GD', dialCode: '+1-473', flag: '🇬🇩' },
  { name: 'Guatemala', iso: 'GT', dialCode: '+502', flag: '🇬🇹' },
  { name: 'Guinea', iso: 'GN', dialCode: '+224', flag: '🇬🇳' },
  { name: 'Guinea-Bissau', iso: 'GW', dialCode: '+245', flag: '🇬🇼' },
  { name: 'Guyana', iso: 'GY', dialCode: '+592', flag: '🇬🇾' },
  { name: 'Haiti', iso: 'HT', dialCode: '+509', flag: '🇭🇹' },
  { name: 'Honduras', iso: 'HN', dialCode: '+504', flag: '🇭🇳' },
  { name: 'Hungary', iso: 'HU', dialCode: '+36', flag: '🇭🇺' },
  { name: 'Iceland', iso: 'IS', dialCode: '+354', flag: '🇮🇸' },
  { name: 'India', iso: 'IN', dialCode: '+91', flag: '🇮🇳' },
  { name: 'Indonesia', iso: 'ID', dialCode: '+62', flag: '🇮🇩' },
  { name: 'Iran', iso: 'IR', dialCode: '+98', flag: '🇮🇷' },
  { name: 'Iraq', iso: 'IQ', dialCode: '+964', flag: '🇮🇶' },
  { name: 'Ireland', iso: 'IE', dialCode: '+353', flag: '🇮🇪' },
  { name: 'Israel', iso: 'IL', dialCode: '+972', flag: '🇮🇱' },
  { name: 'Italy', iso: 'IT', dialCode: '+39', flag: '🇮🇹' },
  { name: 'Jamaica', iso: 'JM', dialCode: '+1-876', flag: '🇯🇲' },
  { name: 'Japan', iso: 'JP', dialCode: '+81', flag: '🇯🇵' },
  { name: 'Jordan', iso: 'JO', dialCode: '+962', flag: '🇯🇴' },
  { name: 'Kazakhstan', iso: 'KZ', dialCode: '+7', flag: '🇰🇿' },
  { name: 'Kenya', iso: 'KE', dialCode: '+254', flag: '🇰🇪' },
  { name: 'Kiribati', iso: 'KI', dialCode: '+686', flag: '🇰🇮' },
  { name: 'Korea (North)', iso: 'KP', dialCode: '+850', flag: '🇰🇵' },
  { name: 'Korea (South)', iso: 'KR', dialCode: '+82', flag: '🇰🇷' },
  { name: 'Kosovo', iso: 'XK', dialCode: '+383', flag: '🇽🇰' },
  { name: 'Kuwait', iso: 'KW', dialCode: '+965', flag: '🇰🇼' },
  { name: 'Kyrgyzstan', iso: 'KG', dialCode: '+996', flag: '🇰🇬' },
  { name: 'Laos', iso: 'LA', dialCode: '+856', flag: '🇱🇦' },
  { name: 'Latvia', iso: 'LV', dialCode: '+371', flag: '🇱🇻' },
  { name: 'Lebanon', iso: 'LB', dialCode: '+961', flag: '🇱🇧' },
  { name: 'Lesotho', iso: 'LS', dialCode: '+266', flag: '🇱🇸' },
  { name: 'Liberia', iso: 'LR', dialCode: '+231', flag: '🇱🇷' },
  { name: 'Libya', iso: 'LY', dialCode: '+218', flag: '🇱🇾' },
  { name: 'Liechtenstein', iso: 'LI', dialCode: '+423', flag: '🇱🇮' },
  { name: 'Lithuania', iso: 'LT', dialCode: '+370', flag: '🇱🇹' },
  { name: 'Luxembourg', iso: 'LU', dialCode: '+352', flag: '🇱🇺' },
  { name: 'Madagascar', iso: 'MG', dialCode: '+261', flag: '🇲🇬' },
  { name: 'Malawi', iso: 'MW', dialCode: '+265', flag: '🇲🇼' },
  { name: 'Malaysia', iso: 'MY', dialCode: '+60', flag: '🇲🇾' },
  { name: 'Maldives', iso: 'MV', dialCode: '+960', flag: '🇲🇻' },
  { name: 'Mali', iso: 'ML', dialCode: '+223', flag: '🇲🇱' },
  { name: 'Malta', iso: 'MT', dialCode: '+356', flag: '🇲🇹' },
  { name: 'Marshall Islands', iso: 'MH', dialCode: '+692', flag: '🇲🇭' },
  { name: 'Mauritania', iso: 'MR', dialCode: '+222', flag: '🇲🇷' },
  { name: 'Mauritius', iso: 'MU', dialCode: '+230', flag: '🇲🇺' },
  { name: 'Mexico', iso: 'MX', dialCode: '+52', flag: '🇲🇽' },
  { name: 'Micronesia', iso: 'FM', dialCode: '+691', flag: '🇫🇲' },
  { name: 'Moldova', iso: 'MD', dialCode: '+373', flag: '🇲🇩' },
  { name: 'Monaco', iso: 'MC', dialCode: '+377', flag: '🇲🇨' },
  { name: 'Mongolia', iso: 'MN', dialCode: '+976', flag: '🇲🇳' },
  { name: 'Montenegro', iso: 'ME', dialCode: '+382', flag: '🇲🇪' },
  { name: 'Morocco', iso: 'MA', dialCode: '+212', flag: '🇲🇦' },
  { name: 'Mozambique', iso: 'MZ', dialCode: '+258', flag: '🇲🇿' },
  { name: 'Myanmar', iso: 'MM', dialCode: '+95', flag: '🇲🇲' },
  { name: 'Namibia', iso: 'NA', dialCode: '+264', flag: '🇳🇦' },
  { name: 'Nauru', iso: 'NR', dialCode: '+674', flag: '🇳🇷' },
  { name: 'Nepal', iso: 'NP', dialCode: '+977', flag: '🇳🇵' },
  { name: 'Netherlands', iso: 'NL', dialCode: '+31', flag: '🇳🇱' },
  { name: 'New Zealand', iso: 'NZ', dialCode: '+64', flag: '🇳🇿' },
  { name: 'Nicaragua', iso: 'NI', dialCode: '+505', flag: '🇳🇮' },
  { name: 'Niger', iso: 'NE', dialCode: '+227', flag: '🇳🇪' },
  { name: 'Nigeria', iso: 'NG', dialCode: '+234', flag: '🇳🇬' },
  { name: 'North Macedonia', iso: 'MK', dialCode: '+389', flag: '🇲🇰' },
  { name: 'Norway', iso: 'NO', dialCode: '+47', flag: '🇳🇴' },
  { name: 'Oman', iso: 'OM', dialCode: '+968', flag: '🇴🇲' },
  { name: 'Pakistan', iso: 'PK', dialCode: '+92', flag: '🇵🇰' },
  { name: 'Palau', iso: 'PW', dialCode: '+680', flag: '🇵🇼' },
  { name: 'Palestine', iso: 'PS', dialCode: '+970', flag: '🇵🇸' },
  { name: 'Panama', iso: 'PA', dialCode: '+507', flag: '🇵🇦' },
  { name: 'Papua New Guinea', iso: 'PG', dialCode: '+675', flag: '🇵🇬' },
  { name: 'Paraguay', iso: 'PY', dialCode: '+595', flag: '🇵🇾' },
  { name: 'Peru', iso: 'PE', dialCode: '+51', flag: '🇵🇪' },
  { name: 'Philippines', iso: 'PH', dialCode: '+63', flag: '🇵🇭' },
  { name: 'Poland', iso: 'PL', dialCode: '+48', flag: '🇵🇱' },
  { name: 'Portugal', iso: 'PT', dialCode: '+351', flag: '🇵🇹' },
  { name: 'Qatar', iso: 'QA', dialCode: '+974', flag: '🇶🇦' },
  { name: 'Romania', iso: 'RO', dialCode: '+40', flag: '🇷🇴' },
  { name: 'Russia', iso: 'RU', dialCode: '+7', flag: '🇷🇺' },
  { name: 'Rwanda', iso: 'RW', dialCode: '+250', flag: '🇷🇼' },
  { name: 'Saint Kitts and Nevis', iso: 'KN', dialCode: '+1-869', flag: '🇰🇳' },
  { name: 'Saint Lucia', iso: 'LC', dialCode: '+1-758', flag: '🇱🇨' },
  { name: 'Saint Vincent and the Grenadines', iso: 'VC', dialCode: '+1-784', flag: '🇻🇨' },
  { name: 'Samoa', iso: 'WS', dialCode: '+685', flag: '🇼🇸' },
  { name: 'San Marino', iso: 'SM', dialCode: '+378', flag: '🇸🇲' },
  { name: 'Sao Tome and Principe', iso: 'ST', dialCode: '+239', flag: '🇸🇹' },
  { name: 'Saudi Arabia', iso: 'SA', dialCode: '+966', flag: '🇸🇦' },
  { name: 'Senegal', iso: 'SN', dialCode: '+221', flag: '🇸🇳' },
  { name: 'Serbia', iso: 'RS', dialCode: '+381', flag: '🇷🇸' },
  { name: 'Seychelles', iso: 'SC', dialCode: '+248', flag: '🇸🇨' },
  { name: 'Sierra Leone', iso: 'SL', dialCode: '+232', flag: '🇸🇱' },
  { name: 'Singapore', iso: 'SG', dialCode: '+65', flag: '🇸🇬' },
  { name: 'Slovakia', iso: 'SK', dialCode: '+421', flag: '🇸🇰' },
  { name: 'Slovenia', iso: 'SI', dialCode: '+386', flag: '🇸🇮' },
  { name: 'Solomon Islands', iso: 'SB', dialCode: '+677', flag: '🇸🇧' },
  { name: 'Somalia', iso: 'SO', dialCode: '+252', flag: '🇸🇴' },
  { name: 'South Africa', iso: 'ZA', dialCode: '+27', flag: '🇿🇦' },
  { name: 'South Sudan', iso: 'SS', dialCode: '+211', flag: '🇸🇸' },
  { name: 'Spain', iso: 'ES', dialCode: '+34', flag: '🇪🇸' },
  { name: 'Sri Lanka', iso: 'LK', dialCode: '+94', flag: '🇱🇰' },
  { name: 'Sudan', iso: 'SD', dialCode: '+249', flag: '🇸🇩' },
  { name: 'Suriname', iso: 'SR', dialCode: '+597', flag: '🇸🇷' },
  { name: 'Sweden', iso: 'SE', dialCode: '+46', flag: '🇸🇪' },
  { name: 'Switzerland', iso: 'CH', dialCode: '+41', flag: '🇨🇭' },
  { name: 'Syria', iso: 'SY', dialCode: '+963', flag: '🇸🇾' },
  { name: 'Taiwan', iso: 'TW', dialCode: '+886', flag: '🇹🇼' },
  { name: 'Tajikistan', iso: 'TJ', dialCode: '+992', flag: '🇹🇯' },
  { name: 'Tanzania', iso: 'TZ', dialCode: '+255', flag: '🇹🇿' },
  { name: 'Thailand', iso: 'TH', dialCode: '+66', flag: '🇹🇭' },
  { name: 'Timor-Leste', iso: 'TL', dialCode: '+670', flag: '🇹🇱' },
  { name: 'Togo', iso: 'TG', dialCode: '+228', flag: '🇹🇬' },
  { name: 'Tonga', iso: 'TO', dialCode: '+676', flag: '🇹🇴' },
  { name: 'Trinidad and Tobago', iso: 'TT', dialCode: '+1-868', flag: '🇹🇹' },
  { name: 'Tunisia', iso: 'TN', dialCode: '+216', flag: '🇹🇳' },
  { name: 'Turkey', iso: 'TR', dialCode: '+90', flag: '🇹🇷' },
  { name: 'Turkmenistan', iso: 'TM', dialCode: '+993', flag: '🇹🇲' },
  { name: 'Tuvalu', iso: 'TV', dialCode: '+688', flag: '🇹🇻' },
  { name: 'Uganda', iso: 'UG', dialCode: '+256', flag: '🇺🇬' },
  { name: 'Ukraine', iso: 'UA', dialCode: '+380', flag: '🇺🇦' },
  { name: 'United Arab Emirates', iso: 'AE', dialCode: '+971', flag: '🇦🇪' },
  { name: 'United Kingdom', iso: 'GB', dialCode: '+44', flag: '🇬🇧' },
  { name: 'United States', iso: 'US', dialCode: '+1', flag: '🇺🇸' },
  { name: 'Uruguay', iso: 'UY', dialCode: '+598', flag: '🇺🇾' },
  { name: 'Uzbekistan', iso: 'UZ', dialCode: '+998', flag: '🇺🇿' },
  { name: 'Vanuatu', iso: 'VU', dialCode: '+678', flag: '🇻🇺' },
  { name: 'Vatican City', iso: 'VA', dialCode: '+39', flag: '🇻🇦' },
  { name: 'Venezuela', iso: 'VE', dialCode: '+58', flag: '🇻🇪' },
  { name: 'Vietnam', iso: 'VN', dialCode: '+84', flag: '🇻🇳' },
  { name: 'Yemen', iso: 'YE', dialCode: '+967', flag: '🇾🇪' },
  { name: 'Zambia', iso: 'ZM', dialCode: '+260', flag: '🇿🇲' },
  { name: 'Zimbabwe', iso: 'ZW', dialCode: '+263', flag: '🇿🇼' },
]

interface SignUpProps {
  onSwitchToSignIn: () => void
}

function SignUp({ onSwitchToSignIn }: SignUpProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { toast } = useToast()
  const [showPassword, setShowPassword] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [selectedCountry, setSelectedCountry] = useState<Country>(
    COUNTRIES.find(c => c.iso === 'US') || COUNTRIES[0]
  )
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [countrySearch, setCountrySearch] = useState('')
  const [password, setPassword] = useState('')
  const [invitationCode, setInvitationCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Referral links point here as /signup?ref=CODE — pre-fill so the person doesn't
  // have to type the code in manually (which is why almost nobody ever did).
  useEffect(() => {
    const ref = searchParams.get('ref')
    if (ref) setInvitationCode(ref)
  }, [searchParams])

  // Auto-detect country by IP with multiple fallbacks
  useEffect(() => {
    const applyCountry = (isoCode: string) => {
      const detected = COUNTRIES.find(c => c.iso === isoCode.toUpperCase())
      if (detected) setSelectedCountry(detected)
    }

    fetch('https://api.country.is/')
      .then(res => res.json())
      .then(data => {
        if (data.country) {
          applyCountry(data.country)
        } else {
          throw new Error('api.country.is failed')
        }
      })
      .catch(() =>
        // Fallback: freeipapi.com
        fetch('https://freeipapi.com/api/json')
          .then(res => res.json())
          .then(data => {
            if (data.countryCode) {
              applyCountry(data.countryCode)
            } else {
              throw new Error('freeipapi failed')
            }
          })
          .catch(() => { /* all failed, keep US default */ })
      )
  }, [])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false)
        setCountrySearch('')
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const filteredCountries = COUNTRIES.filter(c =>
    c.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
    c.dialCode.includes(countrySearch)
  )

  const rules = {
    length: password.length >= 9,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  }

  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    // Validation
    if (!name) {
      setError('Please enter your full name')
      return
    }
    if (!email) {
      setError('Please enter your email address')
      return
    }
    if (!phoneNumber) {
      setError('Please enter your phone number')
      return
    }
    if (!password) {
      setError('Please enter your password')
      return
    }
    
    // Check strong password requirements (9-10 chars, upper, lower, digit, special symbol)
    const isStrong = rules.length && rules.lowercase && rules.uppercase && rules.number && rules.special;
    if (!isStrong) {
      setError('Password does not meet all security requirements below.')
      return
    }

    // Strip everything except digits (drops spaces, hyphens, parens), then strip
    // a leading '+', then strip a leading dial code OR a leading trunk '0' —
    // never both — so it doesn't matter whether the user typed "0712...",
    // "254712...", or pasted their full "+254712..." into the number field.
    let cleanPhoneInput = phoneNumber.trim().replace(/[^\d+]/g, '').replace(/^\+/, '')
    const dialDigits = selectedCountry.dialCode.replace(/[^\d]/g, '')
    if (cleanPhoneInput.startsWith(dialDigits)) {
      cleanPhoneInput = cleanPhoneInput.slice(dialDigits.length)
    } else if (cleanPhoneInput.startsWith('0')) {
      cleanPhoneInput = cleanPhoneInput.slice(1)
    }

    if (selectedCountry.dialCode === '+254') {
      // Validate length (9 digits) and correct prefix (starts with 7 or 1)
      if (!/^[17]\d{8}$/.test(cleanPhoneInput)) {
        setError('Invalid Kenyan phone number. Must start with 7 or 1 and have exactly 9 digits (excluding leading 0 or 254).')
        return
      }
    } else if (cleanPhoneInput.length < 4) {
      setError('Please enter a valid phone number')
      return
    }

    const phone = `${selectedCountry.dialCode}${cleanPhoneInput}`
    setLoading(true)
    try {
      await registerUser(name, email, phone, password, '', invitationCode, selectedCountry.iso)
      toast('Account created! Please verify your email.', 'success')
      // Navigate to OTP verification instead of dashboard
      navigate('/verify-email', { state: { email, fromRegister: true } })
    } catch (err: any) {
      const msg = err.message || 'Registration failed'
      setError(msg)
      toast(msg, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      {/* Left Panel - Image */}
      <div className="login-left-panel">
        <BicoinAuthPanel />
      </div>

      {/* Right Panel - Sign Up Form */}
      <div className="login-right-panel">
        <div className="login-form-container">
          {/* Header */}
          <div className="login-header">
            <div className="mobile-logo">
              <BicoinLogo height={40} className="mobile-logo-img" />
            </div>
            <h2 className="login-title">Sign up account</h2>
            <p className="login-subtitle">Enter your personal data to create your account</p>
          </div>

          <form onSubmit={handleSignUp}>
            {/* Name Input */}
            <div className="form-group">
              <label className="form-label">Full name</label>
              <input
                type="text"
                autoComplete="name"
                placeholder="E.g John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-input"
              />
            </div>

            {/* Email Input */}
            <div className="form-group">
              <label className="form-label">Email address</label>
              <input
                type="email"
                autoComplete="email"
                placeholder="E.g John@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
              />
            </div>

            {/* Phone Input */}
            <div className="form-group">
              <label className="form-label">Phone number</label>
              <div className="phone-input-wrapper">
                {/* Country Code Dropdown */}
                <div className="country-code-dropdown" ref={dropdownRef}>
                  <button
                    type="button"
                    className="country-code-trigger"
                    onClick={() => { setDropdownOpen(prev => !prev); setCountrySearch('') }}
                  >
                    <span className="country-flag">{selectedCountry.flag}</span>
                    <span className="country-dial">{selectedCountry.dialCode}</span>
                    <ChevronDown size={14} className={`dropdown-chevron${dropdownOpen ? ' open' : ''}`} />
                  </button>
                  {dropdownOpen && (
                    <div className="country-dropdown-menu">
                      <div className="country-search-wrapper">
                        <Search size={14} className="country-search-icon" />
                        <input
                          type="text"
                          placeholder="Search country..."
                          value={countrySearch}
                          onChange={e => setCountrySearch(e.target.value)}
                          className="country-search-input"
                          autoFocus
                        />
                      </div>
                      <div className="country-list">
                        {filteredCountries.map(country => (
                          <button
                            key={country.iso}
                            type="button"
                            className={`country-option${selectedCountry.iso === country.iso ? ' selected' : ''}`}
                            onClick={() => {
                              setSelectedCountry(country)
                              setDropdownOpen(false)
                              setCountrySearch('')
                            }}
                          >
                            <span className="country-flag">{country.flag}</span>
                            <span className="country-name">{country.name}</span>
                            <span className="country-dial-muted">{country.dialCode}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                {/* Phone number input */}
                <input
                  type="tel"
                  autoComplete="tel"
                  placeholder="Enter phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ''))}
                  className="form-input phone-number-input"
                />
              </div>
            </div>

            {/* Invitation Code (optional) */}
            <div className="form-group">
              <label className="form-label">Invitation Code <span style={{color:'#71717A', fontWeight: 400}}>(optional)</span></label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Enter referral code if you have one"
                value={invitationCode}
                onChange={(e) => setInvitationCode(e.target.value.toUpperCase())}
                className="form-input"
              />
            </div>

            {/* Password Input */}
            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="new-password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>

              {/* Password Strength Checklist */}
              {password && (
                <div className="pw-checklist">
                  <p className="pw-checklist-title">Password Checklist:</p>
                  <div className="pw-checklist-grid">
                    {([
                      [rules.length,    '9+ Characters'],
                      [rules.lowercase, '1 Lowercase letter'],
                      [rules.uppercase, '1 Uppercase letter'],
                      [rules.number,    '1 Number'],
                      [rules.special,   '1 Special symbol'],
                    ] as [boolean, string][]).map(([pass, label]) => (
                      <div key={label} className={`pw-rule ${pass ? 'pass' : 'fail'}`}>
                        <span className="pw-rule-icon">{pass ? '✓' : '✗'}</span> {label}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Error Message */}
            {error && <div className="login-error-message" style={{ color: '#ef4444', fontSize: '14px', marginBottom: '16px', textAlign: 'center' }}>{error}</div>}

            {/* Sign Up Button */}
            <button
              type="submit"
              className="signin-btn"
              disabled={loading}
            >
              {loading ? 'Creating account...' : 'Sign up'}
            </button>
          </form>

          {/* Sign In Link */}
          <p className="signup-link">
            Already have an account?
            <button type="button" className="signup-btn" onClick={onSwitchToSignIn}>Sign in</button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default SignUp

